import { BadgeVerificationStatus } from "./BadgeVerificationStatus";

export interface ClientFeature {
    name: string;
}

export class Client {
  clientID: string;
  name: string;
  description: string | null;
  latitude: number;
  longitude: number;
  //clientTypeID: string;
  clientTypeName: string | null;
  //createdDate: string;
  //modifiedDate: string | null;
  badgeTypeId: BadgeVerificationStatus;
  clientFeatures?: ClientFeature[]; 
  website: string | null;
  email: string | null;
  phone: string | null;

  constructor(data: any) {
    this.clientID = data.clientID;
    this.name = data.name;
    this.description = data.description;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    // this.clientTypeID = data.clientTypeID;
    this.clientTypeName = data.clientTypeName;
    //this.createdDate = data.createdDate;
    //this.modifiedDate = data.modifiedDate;
    this.badgeTypeId = data.badgeTypeId ?? BadgeVerificationStatus.NotVerified;
    this.clientFeatures = data.clientFeatures || [];
    this.website = data.website ?? null;
    this.email = data.email ?? null;
    this.phone = data.phone ?? null;
  }
}